import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout30',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_1',
      parent: '2',
      data: ''
    },
    {
      id: '7c1bb109-4f15-4e0c-8f34-607de8dc9454',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_2',
      parent: '2',
      data: ''
    },
    {
      id: '5fc8759a-5b41-4519-adc8-a415aa19fc46',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_3',
      parent: '2',
      data: ''
    },
    {
      id: '6d8de3d2-14bf-4328-963c-067fe39975d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_4',
      parent: '2',
      data: ''
    },
    {
      id: '50e0d927-40fb-4d0a-923c-ae2b678a357d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_5',
      parent: '2',
      data: ''
    },
    {
      id: '15298b51-52cd-432b-8085-f5e187ce9610',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_6',
      parent: '2',
      data: ''
    },
    {
      id: '522b0c39-6790-4b09-bb9c-b18fe8a1926e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_7',
      parent: '2',
      data: ''
    },
    {
      id: 'f5f35e89-a043-436f-a83b-2fc48260753b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map30_export_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 272,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7d1d1b53-8f22-4321-8c48-b3ec768512e7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 337,
      y: 421,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '10e087e6-5a8b-4025-86fe-9df26d195e92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 428,
      y: 445,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7beed302-23f2-474f-8cf1-4f755e906ae9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 502,
      y: 392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '841b06dd-99e6-4596-a046-5518d3975331',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 574,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fb7f9e25-fc51-45e5-8be6-86907c3016c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 663,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b7d78055-5832-4289-864c-e090567df3bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 752,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '85735768-2316-4f23-b366-04125ec355ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 819,
      y: 401,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '99315829-8f52-4999-be1e-a495b8829ec7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 906,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '79f65473-5f09-4199-ba2b-e4161d58ef7d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 974,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e46f7355-bee5-4dfb-83d9-e8d506ec3859',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1039,
      y: 314,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6d0d43e4-09da-4805-ac69-3928da4f3ec1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1115,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd37078f6-2c37-46a2-8c7b-37e06051e7d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1206,
      y: 245,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3f65562c-dba5-4d85-a12f-7ac47330f471',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1284,
      y: 290,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '772f13a6-ee05-46cf-b367-2a9956deecb9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1310,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '14503d04-abf3-48eb-a663-0273b43a1560',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1391,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2ccc6864-e03b-44fd-8c59-63bf858b7244',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1450,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '93d45111-f415-4ac2-a22f-cc6c82c1eed0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1549,
      y: 493,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5a593189-fea1-4579-a23c-7dd6b88d96bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1639,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6b44827f-4520-4d97-8fd3-fd45908e5099',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1718,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '05bb82bd-dca8-4050-86ea-ec6230f08ed5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1806,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'acf8dd56-bb4d-41b1-bd37-755c575d26bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1908,
      y: 332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'df3ad68e-26ee-4cac-8fbc-4fcc3e51e8f8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2002,
      y: 369,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '844f7c4e-fde1-4b40-aae4-4cee2ffb5717',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2096,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ec2d957b-e8b1-48ee-bb73-de42d22e9af2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2197,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2487c086-6254-4cb4-82d1-91a32c4d85fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2293,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4be970de-6dc3-486f-b912-581711481de2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2386,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b88e8e79-40f8-4222-af30-231d1eaa4a31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2461,
      y: 444,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2c4bd9ec-7e69-4f28-ab1f-78c05ae6c336',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2548,
      y: 480,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '26921fa8-af59-42fb-9f8c-0ff8045528b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2647,
      y: 480,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7d4461a6-81c5-41a8-98b5-90b7e5b9cb26',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2738,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd6a59722-0285-4170-867c-4ae92ca43e11',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2824,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e5399a06-3d66-4b8e-8ebe-e93326a1cbaa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2911,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0d72ab60-4062-4bca-bb9f-29b323dfb331',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2995,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b5a3ee94-3312-447c-a395-67727b764166',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3087,
      y: 369,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '26f3a3cf-81f8-4176-a1a0-937e72a8da56',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3166,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '88e33de3-0c78-44d3-a211-81fed4aff037',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3260,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7556df0e-a440-4a8c-af2f-42005f2a5b44',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3357,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd4ffd19a-f2b7-4324-b513-62c362ed8cd0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3444,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cb77b801-abcb-41b0-aee0-e6b660b3f071',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3540,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '18b47955-c370-40b5-990f-ecc33f2efb7e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3627,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '947503dc-75a1-4fb8-adbf-9505470636a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3719,
      y: 323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6c14b6d3-8a89-4dd6-81ce-00bb5354d0d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3808,
      y: 295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f523e027-ce17-46a4-a3df-3e85459e307b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3900,
      y: 269,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1e6143a1-8a29-42df-9341-a85e0de25795',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3997,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'de2a4c77-6f7c-44de-9b00-2a4ff0bc4d7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4085,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c87d6eb0-2069-4d88-86ad-243044820d64',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4164,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd1a5e7b0-89ea-46de-b6a2-2e5aeba1245b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4236,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '293398ed-23be-4700-b4ee-0b4fec223c96',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4323,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fd9940dc-0f94-4392-a1aa-da1996fc8f35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4422,
      y: 493,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a52b8cdd-b4e3-489e-87fe-92d857769036',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4518,
      y: 464,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '34a30cea-976f-497d-9361-eb1eaae19bd2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4602,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6e49744b-e404-4dd9-8769-52e274e311c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4682,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '175ee24e-156f-4d87-a228-133525f6b35d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4765,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '08ddfe18-1a41-4523-acba-0343972ff14d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4861,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd595e5a5-3f39-4443-ac57-d3ec9df8fd90',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4960,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '23dcadf9-f8e5-4e23-9992-dd3fc60e68a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5044,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '281f6f93-f247-4d6e-8bd2-4b49a0b23811',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5137,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c03c6187-10a0-42db-954a-487e88967d02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5242,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c6833073-07c5-4efe-8c90-8bc2ccf10276',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5342,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e88ea30a-2b8c-4ea5-95e7-eae81de48e9b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5442,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fd12db78-cb00-45a5-ac5b-4cd14ed85cee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5537,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e7dbdc31-8714-4d2e-acae-e43a5976c601',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5625,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ae1fe788-58f1-41b5-8c1d-d6fc381704d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5717,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2edb9c1d-b9c3-4453-9bf8-2fdbf3c13bd9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5811,
      y: 421,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '72cd0548-1de7-44e8-987c-697fd49cdebb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5907,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3267a9ac-ecfb-4723-914c-0b10f25d3372',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6000,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '10ba61d5-62f8-48b7-a848-dba5a39d616e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6089,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2616ccb0-1871-4880-b985-fdd14f9fc986',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6182,
      y: 380,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6957447c-1b54-4f83-9471-3823ec3f6137',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6278,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3d053f8c-fd85-479b-9b9d-d8024286cdf9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6369,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '852c0e32-c8c2-4c35-a99a-a713cea0fa7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6435,
      y: 299,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '580b5e36-79c7-4a7f-b432-6adbb55ff9c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6515,
      y: 257,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '81a3deb7-6872-421a-b5b4-b21f8a7448cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6606,
      y: 234,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2ef38dce-e1a9-4538-9a68-c4a5ad68462e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6702,
      y: 242,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a6d83a01-9248-4ec4-8d52-d5ec51683452',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6803,
      y: 259,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a6bd6ba4-20c7-4fc6-886d-673fe9ac2cfb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6895,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5b81605f-8d5e-431c-809d-3931e7d8c283',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6971,
      y: 339,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1cbdd9b2-3bbc-42d5-be28-2c6d16b00fec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7055,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3e2c5a97-691c-4768-99f2-3ed84cb35d4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7135,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4f6473fb-6d43-42a9-aaf8-1a6ea2ec60af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7219,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7f889aec-c0cc-47fc-9514-a656ace47ba5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7313,
      y: 511,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fc7436ea-da4c-4677-a1df-bf649ab7809b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7413,
      y: 533,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ee54fe14-210b-4ba5-af9e-9a8cc8e9919d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7509,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '71358054-72c3-440e-ab76-c3bf86174623',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7596,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2b692e4a-4f17-436c-9b4b-50530739c001',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7676,
      y: 435,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '05102aae-f27b-4982-9d84-443af58a1074',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7759,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7147f61e-cea0-4e73-b7c8-7b72b3a57694',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7852,
      y: 372,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '71afd5af-e82d-4748-9f57-984a260674c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7945,
      y: 352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '28e93d9a-13d0-4c56-80a3-897caee83a66',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8035,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30f12f15-1f3d-4911-8c82-ce7e3f0513b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8132,
      y: 321,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f3a17d13-e689-4fee-b77b-0a1bffb3c6d7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8232,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd64169e8-2f2d-4fa4-a375-f40bd0d45bad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8318,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '590c882c-110c-4649-8798-dbd61b076505',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8404,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cc5210fd-3fda-47b7-ae47-a249646bd0ac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8494,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f1f8fb74-3ca2-48a4-b73a-52de52e33ac7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8589,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5ebbfcb2-03dd-421f-afd1-904a999a330f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8685,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd42137a0-04fa-493a-95a3-8baff2cf57ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8771,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c0d6d9f1-4bc4-46a3-8406-670aa039c8a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8854,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0fa78a5f-0091-4f80-b6d1-4a73895227fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8946,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '764cdef6-30a6-4c42-9e58-d553773d829b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9044,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ec9f2ef4-89ee-43b5-8fa9-6ebebb459da3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9138,
      y: 345,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '68d79f36-6a22-495c-a35e-87b571aefd5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9213,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3461cb6f-fa19-4e5e-ac18-9f49f67bf266',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9296,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '99b5b6dd-bc9f-4ea3-b8d2-6d52f547915d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9390,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd3ac496b-0dc0-4698-945b-a42c9ee1d759',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9475,
      y: 395,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dbe4978d-28f1-421c-bca3-7f9150125f34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9531,
      y: 328,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '27799902-8848-4ba3-9546-0d0bf198666a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9590,
      y: 261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '978b6496-b990-45c4-a116-dc47eb8087dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9667,
      y: 211,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '96057f08-e06a-4081-a4a7-72a8cc01b3c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9760,
      y: 193,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '76e2f370-cd3e-468f-80c1-682e4c69e0a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9854,
      y: 202,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4963d123-053c-4f47-9b12-c715d1c0020c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9930,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c59869c7-4e02-4fa4-9cff-df291605d9b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9961,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bf52c16f-d675-4e08-b402-b0ac4e025fad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9991,
      y: 405,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '277b831d-3691-4562-8db9-622e41e6f71d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10039,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b5d699b8-3b64-4fd2-9a4e-f96068ba34e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10117,
      y: 522,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '35cff990-820b-48ef-9b5b-1a671c099bbb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10208,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '13d260ae-5a1a-4145-b77a-aeb92a833ca8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10268,
      y: 435,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '25842dcf-f426-4636-ad83-d97d6bf87294',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10356,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f79d2ed6-a97c-4c44-a884-7aabf66d0ac3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10449,
      y: 421,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '631194d4-ad73-4366-a65f-21797e8dc249',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '74092e03-0544-42a0-a499-3278f19873a5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '583acaed-3914-470b-a17f-69f0e67d92ab',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '491d40a9-8b97-45f8-b42a-474dc5f3d592',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1061,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c2aafe08-80cf-4c40-9949-4b97bdf884fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1160,
      y: 711,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fc9ede1f-b255-4a25-9e63-c74a3f4f7540',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1104,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '6fde6864-7e23-44f1-9f74-032d34bc09a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 922,
      y: 679,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd9ecb0f8-5a59-4cac-b1e6-5e06383f9cdc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 961,
      y: 843,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '802d6e80-1d74-4e28-a3cd-5f774abd4169',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 835,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '2fbb240c-f7e9-4129-bbb2-ea42a486602f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 718,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ad7c88b7-ef3a-48d2-8d05-4541d250bb7d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 811,
      y: 863,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c52975df-11dc-472b-ae10-d8bf7ce5dceb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 724,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '64de016b-e0b5-4ee1-a3e6-9b26a3873159',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 587,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b3bd4e74-4a4d-4bd7-93b5-18db71a105a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 590,
      y: 814,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c4052925-840d-4fdb-8fee-6e7dff7c4130',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 454,
      y: 714,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '370543f5-b33c-4587-8823-8d1a4e34a565',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 313,
      y: 692,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '996429d9-1a88-42fe-b4cf-b6e2e7341365',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 384,
      y: 846,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f4aa6a00-a1d9-4bf0-9fd7-49b6aa11dc75',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 186,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd7f5e192-1691-4c0c-bce7-613edbb410bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 238,
      y: 837,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '36a7b7ac-a9a0-4cf7-9be0-5f916ae93031',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 671,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '1430844c-9095-46e6-9e0c-757672a63f06',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 761,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cc777ae9-2393-4c85-aca6-0a14efceb16c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 899,
      y: 117,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'afefda23-e72c-4676-8fe5-fa10f607acce',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 822,
      y: 233,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '8517fc08-aa0a-4644-98e5-1ff875b73ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1028,
      y: 133,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e0886011-17bd-4f0d-9b40-57301328af6d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1297,
      y: 113,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: '627c1c74-5c11-413b-bf1d-ce36a2e53d28',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1148,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e308d443-9301-4551-8486-e02dad33e854',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 945,
      y: 250,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ae29c6ed-42a7-4748-a628-70990b43f021',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1396,
      y: 187,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '60f30ca5-94ee-4f69-9791-f6c1213f90b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2211,
      y: 277,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '5390ec5c-20e3-4792-a663-44a07c84aa55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2114,
      y: 189,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '8cf5a567-94ab-4979-91c9-577924cf2fb0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1995,
      y: 111,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f50b7a8a-77cf-4028-bf8f-9b11ca106074',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1534,
      y: 74,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '6b75bad4-a071-4420-af91-5ec1157a8424',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1980,
      y: 210,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '03e0a093-bd63-4c60-93fe-1db120134ec2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1883,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a1afcb15-fc7d-430f-9449-dbe3de4cba5a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2364,
      y: 91,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c9c18417-9116-4206-aa63-0ea4a2e9a662',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2311,
      y: 237,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f8932fa4-f1cc-4029-9f1f-bd9b4463d8ac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2659,
      y: 93,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'cebac9aa-44e9-4942-8736-26c3510f7056',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2522,
      y: 97,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '79078ce3-1c7d-4145-ad0b-1a0369fd0854',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2221,
      y: 70,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '7fc637a8-5b59-4b2c-95bc-1039080488cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2435,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '6533d415-a064-4585-a7f9-9bff31b27565',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2560,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '6d230238-9cb0-486f-8a2a-7c880191b766',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2658,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '72e71a73-c97e-4d28-a010-ac7213b92f5e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1678,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '5b8cc806-2ced-4f0c-82e7-e8c3afeb61b7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1823,
      y: 651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ed693420-8e96-4687-98f9-7af037c7af4e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2014,
      y: 623,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b2279140-1846-4e18-9b39-83128d87356f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2141,
      y: 642,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b7a2b6f3-ac76-4f2a-bb69-e5d3223b3c92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2280,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '08977d8f-6512-475c-9bb0-c46086e95a43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2357,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'd1b03e23-9b5c-40e7-a139-80dd301b40aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2401,
      y: 747,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '5bf970d1-5da4-4367-983d-112f74a87f6c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2270,
      y: 746,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '9d9ec311-4c03-40b0-bdae-97cc9733aca6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2160,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '57299714-1126-4621-b438-6203acea72bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2025,
      y: 738,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ba036960-cb27-4552-9afa-b2f5141c33c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1907,
      y: 701,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '94117673-0ed2-4a26-ad0a-68f277fbd241',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1822,
      y: 822,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'e9c77b70-1e73-416d-8ad3-306ca1ff7175',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1726,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: '3cbff6eb-78e8-4520-8929-5ecb0dd313cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1564,
      y: 742,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c3ce5426-0b18-4737-9e7e-135a7972a765',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1668,
      y: 817,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c6c800ae-1a02-48d2-b3f0-22fbda3e3d8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2098,
      y: 827,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_4',
      parent: '110',
      data: ''
    },
    {
      id: 'aa7c71be-cdab-4fec-9e9b-01c1fdfa363f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3173,
      y: 606,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '8e839c96-6e21-4369-b603-b908c41095c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3276,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '21863d8c-cbd8-4521-8bda-a310f28536df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3405,
      y: 70,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '50d4b2d0-b535-4508-becd-ec7a6f0a8db1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3538,
      y: 39,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '186a7e81-9f1e-41b5-afa3-7325ad5ab536',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3670,
      y: 57,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '5d0930d7-09de-4743-bb1a-2d0c0273dee1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3806,
      y: 65,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '4ce1fcf6-43d2-467d-8270-c26243911759',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3944,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'e21234b8-931e-4555-b41f-42c466fe7d57',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3364,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '3d3b9f16-493b-4050-85f3-b031a402ec5c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3536,
      y: 134,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9926808d-1ce5-4415-859a-cf1311cfa296',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3666,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b5585d1f-2697-4cba-9e1d-990529a379f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3803,
      y: 121,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '45221119-111e-4fad-85d0-679cdabec9a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3931,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '29405a39-1289-47a7-8493-45e1b8e64ca2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3469,
      y: 220,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '34d1fcf8-2981-4a0a-b1b9-0fa5b7e32322',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3619,
      y: 220,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b1cbfa68-2068-4f44-b3e9-ad715df8c1ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3772,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '57f67764-a7b5-41b5-b3bc-b523341c9576',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3318,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'ee354d38-a087-4d3f-8390-5a7a28420348',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3449,
      y: 628,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '82d50f6e-54c9-480d-8722-530aed1beb80',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3586,
      y: 626,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'a2546d7d-4970-434a-b19b-e310f7ce833a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3711,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b9915cf3-3051-40b1-845b-912b08c5f98a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3869,
      y: 552,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '4acdd4b2-2816-4c2c-8938-bc810cc66c5a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3092,
      y: 703,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '24087c74-f8e2-448b-b2ee-9849f92ab621',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3216,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '027eb226-491d-4bea-865e-43cb50ab3ddc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3354,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'd41b87bb-c21c-4b4f-8683-cb7835b5d6bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3495,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '4f0783e3-6a05-4ef7-a82a-8ebef452482c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3652,
      y: 687,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9979e6e9-4158-409f-8b0a-ff6ede4fca2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3805,
      y: 659,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '946f6c29-e594-48ac-aac7-47b0948d1213',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3935,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'fcad6ac3-f381-4c57-b505-4622d5dfb3cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3127,
      y: 832,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '4c64d335-73ff-4792-a7f1-ae61da79d99d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3288,
      y: 855,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b9480a66-1aad-4665-bae9-c618c4c0d62e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3431,
      y: 853,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '7f92679f-9740-4c4b-9309-80347708bf32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3578,
      y: 823,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '5979a3a9-d9bb-4a3f-8351-f888608554ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3862,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9955e495-e9d6-402a-aa8f-09a6a78dab4b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3739,
      y: 789,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'e2ca324f-5430-4b29-b52d-fbbcf58dc539',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4316,
      y: 102,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '5880f859-84b0-41e1-a701-1d81a44bec17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4422,
      y: 140,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '72472007-5019-42c0-bc6d-3a8876448cd7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4516,
      y: 54,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '6512eb58-7fa4-45db-a304-c4f2270ee0ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4308,
      y: 227,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '2032575b-164c-4160-a900-d9757436ca16',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4428,
      y: 239,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e9ec885b-b9a5-40c1-8699-673c42c60e03',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4523,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '65161f0a-31a4-4404-ad07-f9952ee85409',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4625,
      y: 68,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd2dbff0c-47c8-40b3-b550-ec3e810c32d7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4603,
      y: 214,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a213b899-dbe6-4def-a6d7-6c542cf1cfe0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4698,
      y: 130,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '3292a0ab-0348-4c1c-8482-7dd942fd5c0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4789,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '904cb363-741e-4808-bc07-1298f04cf904',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4907,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '876180b6-0d3c-421b-91ef-d44f714ff5e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4824,
      y: 132,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '3e94c781-fad6-42fd-8cdb-d10709c97df8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4744,
      y: 201,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '53993e9f-e6c8-4468-a389-c279e4d7f922',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5054,
      y: 68,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '2c0359e8-4a91-43a9-8667-d4ff9630ca17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4965,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'cb28a2f8-f427-42c7-bca7-d3e10a2f221f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4891,
      y: 207,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '6e7d3809-9597-463f-b6c8-ffa5dff4b66b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5196,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a716a9b7-98f7-491f-a6a4-edf98b82fd7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5103,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '4f004fca-2fea-42a2-bc9c-8933045c8bb3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5016,
      y: 194,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '882ddf9d-951c-4065-9861-73db9d2ab207',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4901,
      y: 527,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '623f66c8-cfaa-4b19-8074-423b37492848',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5007,
      y: 581,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'b3cf0408-d316-4c89-9f7b-1f3a762faa9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5111,
      y: 646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '2d7db1a0-a0a2-4c12-ad58-fddcbfbb7e8b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5199,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '297c51ab-d628-4bee-895f-5a0707936ad8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4817,
      y: 568,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '393bdc2b-0023-489a-a037-bb0a9724e6ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4923,
      y: 643,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '5326c6b0-1e06-4803-aeb3-1be9bbaa6be5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5044,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd085fc40-974c-47fd-848a-084dbeb28954',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5131,
      y: 773,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '823e1819-f5c0-4c26-9353-e12c9ff685ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4731,
      y: 605,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '31499189-e531-41b1-87f3-ef617966947b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4840,
      y: 687,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e8c504e4-ffbe-41da-92bd-7e59ff9d3a2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4955,
      y: 751,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '7ab6ff90-c144-4c34-861f-6657ab09acf0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4664,
      y: 653,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '5a7d0744-472c-494a-82e1-c8bff6b16f68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4762,
      y: 733,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '093ae6af-d089-4718-a32d-72e4bb4ed539',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4869,
      y: 819,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e609748e-e5b0-4594-b2cf-125c122e179d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4551,
      y: 693,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '297683ea-bcf1-4185-8531-1e83363027b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4660,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: 'ca398293-6caa-44ca-94ac-e730fd56d8af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4762,
      y: 889,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '7110ac96-10f5-4537-a0c2-a3061fc3091e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4428,
      y: 709,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '3a78d941-614b-4de4-98b4-8eec96293f5e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4558,
      y: 778,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '4819b5f1-f1d9-438e-9e65-6fa3092fcd5e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4319,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '60dcf683-26fe-4b6b-a346-8b078601b69f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4435,
      y: 834,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_4',
      parent: '185',
      data: ''
    },
    {
      id: '875432ef-d9a5-4c8a-a5eb-ab51688ddcf2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6595,
      y: 433,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '0f090741-519d-472d-92d2-e8762c7b1fae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6487,
      y: 517,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '9eee2d77-1bbb-4120-86af-217bb6645e1b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6372,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '09ff696a-00cf-437f-b468-56ce3f50ff2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6743,
      y: 444,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '37065ac5-45ba-4f4b-b6d0-666ae3bcbb58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6633,
      y: 519,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'e2d52186-fd4b-4695-bb66-f8295821e5ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6511,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '5c43e5df-9826-43f1-ab8e-f77f426175ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6406,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '513e402c-aebe-477e-9d07-e5d8e9d96b15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6772,
      y: 516,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'ab1dde49-5c05-413b-87c5-41ed9dd58d25',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6675,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '724df550-6a54-4ac9-86cb-ecf8b23319db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6582,
      y: 648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '0af547d9-b381-4a4b-bb41-7661e27f2acb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6498,
      y: 702,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '573e74c2-ecf1-4e50-920c-8273e77b98cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6416,
      y: 788,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '365a60af-dcbe-42ce-885d-40b484ee0acd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6884,
      y: 541,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '68602309-89a0-48f9-b087-8b86c890bafa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6800,
      y: 599,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '1f49b60f-072c-4769-aa45-64ca281bfba3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6707,
      y: 656,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'c9a5a41e-40fb-4c22-8f30-c320f04c061f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6618,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'da93cdff-9456-4f46-a689-6c87a6fb19a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6541,
      y: 777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '35712d89-1641-4749-a07e-d55aa97ddecf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6924,
      y: 607,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '5d8943b0-c031-499a-abe4-cf4c09047b2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6840,
      y: 663,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'cf7b368a-2388-4226-8b7d-85943460e59d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6766,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'd18834d3-8008-46dd-a39f-c0fcae4038b3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6690,
      y: 789,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '53baecd4-5b70-4965-bfba-231e197f44e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7046,
      y: 625,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '6b1a8e04-6908-4f74-88b4-0a031020da99',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6948,
      y: 683,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'df09a379-2168-47f0-9579-41f1afd284fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6857,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '6dca337d-32bf-4eef-944c-9bb0656f11af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7107,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '91d86963-a3cd-413b-b362-dd054991acc0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7011,
      y: 750,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '463cbea6-4909-4ef2-b2db-a5669bc28db2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6903,
      y: 826,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'd37d3673-075e-426b-96e3-1618e326514b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7144,
      y: 762,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '41df29ba-0152-4d02-801a-29579d99f353',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6522,
      y: 60,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'a99892f9-ab74-4ac3-8716-4d071f0ea51e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6424,
      y: 161,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '35b218d5-18d4-443d-8656-b51959aeeed5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6637,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '96cf1f19-3fcb-4434-8b66-319e0f032d2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6543,
      y: 175,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '18a61fe0-1c3f-4e55-9760-1345678f85c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6793,
      y: 44,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'c99197e8-ef63-421a-8887-686f16d6b848',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6694,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '0b807d4a-cdee-4411-941d-0c5809825430',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6876,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'b72652d2-f825-4789-875e-a6e1daf0d559',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6796,
      y: 164,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '896b2da2-c8eb-402d-b515-9ce2b92fb54f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7049,
      y: 54,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'abec876d-89f7-4f9d-925f-08f0706b1d83',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6978,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'f45d0eef-ad1b-4602-a014-faaa804527b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6895,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '41da468f-66b0-4e8e-84ef-26df27dede1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7182,
      y: 63,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '20994d68-ac6b-4db5-9829-c9036fe13599',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7096,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '747e4435-6a9b-4d94-98fd-b299cbc848de',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7020,
      y: 201,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'e529218f-5913-4940-9d50-504bab897a88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7340,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '981c9067-890f-4893-99f5-661bf904c207',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7242,
      y: 117,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'd415f876-044c-40d1-b119-ac492d16c870',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7163,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '4ee58d90-880b-49b7-9c03-eeb9891a94c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7104,
      y: 237,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '4ea74a09-9dfb-4560-bede-e0bd80a77f67',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7451,
      y: 82,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '271d2863-62c3-423f-bff1-c45d7e3eb4ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7365,
      y: 134,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '5085f228-c677-4a9d-ae2e-476cb683b439',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7274,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'fe47cc6f-ccd2-4a42-9e0e-24272ec04ece',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7569,
      y: 711,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dfe07f2d-dca2-4d2b-b530-c01477dcdfd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7766,
      y: 664,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: '7a860b8b-26fd-4170-b5c8-61d8f55e2543',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7691,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'bc1bedfb-3b80-44a6-a75b-f5e9ff4ea671',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7960,
      y: 709,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a471fba8-5f4d-4c8e-a78b-1ac4040d1c31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7838,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: '1ef8397a-1476-457e-b853-c879e4bd4393',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7505,
      y: 786,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'faa5b2c4-f12e-4e1d-b032-194eef7ccf1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7625,
      y: 820,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: '7dd476ca-7cd9-4811-ba36-363344f12dac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7781,
      y: 822,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'cc136700-7e4d-493b-b9bf-ec398c73f49f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7901,
      y: 788,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c456190e-e13d-4c4e-a861-5f31e2cb3058',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8012,
      y: 809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_4',
      parent: '219',
      data: ''
    },
    {
      id: '2eed4d63-9a22-4384-a7de-1d8ec7e112b4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8617,
      y: 23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'cb6574fd-ba9f-4024-a7ea-6037833dfcd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9194,
      y: 133,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b2a0f2fb-4e9b-4d7b-91a0-24578b351d1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9388,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '8f62a870-51e7-494e-b6a1-5321da0169d1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9226,
      y: 248,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '6c53438a-0513-4bc8-b2df-2e0983c2f62a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9368,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '66bb18a7-b5a6-4d1f-b492-b1a172e15233',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8817,
      y: 54,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ae4de424-d415-4f00-a777-6aef3ffd7803',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8991,
      y: 81,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ea525aa4-0087-499e-ad78-6c22c77907c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8433,
      y: 103,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '9bd9623e-8bf4-4bc4-9217-a838f8992ef4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8546,
      y: 166,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e7de0365-2749-435a-af5f-546c53ae3165',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8709,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '3b5fa2cc-5b91-4707-9bce-efa64410c3a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8906,
      y: 184,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '6876bb18-dca0-45a2-a70e-8bd85099973a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8802,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'cf71d482-50f9-480f-aedd-0e2fea8adfe0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8318,
      y: 178,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'af8670bb-7628-4be4-adf7-2fe5c005c459',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8424,
      y: 291,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd6baebca-886d-42d5-b267-e8fc6f80ac82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8621,
      y: 299,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '06cf6251-c4f9-4c6e-a357-4ef2b51561af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9425,
      y: 690,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '80fab66f-22dc-40ac-8f43-1e23478d6a95',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9059,
      y: 592,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '2b067842-85b4-4d63-8e11-ca0bea5da5ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8897,
      y: 620,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '91999b79-4a85-46f4-900f-aa8d72d100cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8741,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '912a2d39-5c34-4119-b053-c5e972076198',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9127,
      y: 714,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: '747e06f4-727c-40b8-8746-3e507a5dff0c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8971,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b5a9d351-1d1e-4743-9710-921eb3dae0ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8833,
      y: 773,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e3337461-7e32-4112-a92d-001045cb489f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9551,
      y: 77,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'a1c46d32-b777-47f0-aaed-9f47b1a651bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9794,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '73cf4c84-6bdc-4322-ba43-6ad3f81f8322',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9686,
      y: 123,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'db1efb7c-11bb-43bf-8705-699dfe008086',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9520,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '87314e16-94ee-42f9-afc9-9183b872b0f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10238,
      y: 73,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '79213017-4b49-456d-a4d8-ff89eb7ffae0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10036,
      y: 93,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'c20c2cd3-4d66-4ddc-94c9-f60e7150b11a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10135,
      y: 161,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '72814b2f-9741-465a-a7ca-dc650f8055b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9892,
      y: 141,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'fc6ae30c-44cf-4743-9b12-3513b7683748',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10029,
      y: 231,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5ab4e187-e1f0-4b8d-8268-492b710325d0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9777,
      y: 457,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b8359f8c-9d7a-4871-8685-88e053ec8e19',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9619,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'dcfcca99-a4f2-4336-8353-c39a4debc007',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9902,
      y: 611,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '81394f3c-bab3-4888-a686-ee8252eddd46',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10239,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '1a9fd9e9-de7f-4240-b0e6-0bbbff27da26',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10049,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '3c8121e1-f42e-44c9-a607-ee415d8d154a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9742,
      y: 623,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '0886a74d-d6a0-4b23-9fe4-5620d4868c1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9607,
      y: 724,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '92e9a555-a5c0-4118-9085-6540bf10329d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9835,
      y: 742,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 871,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2070,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3472,
      y: 216,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '631194d4-ad73-4366-a65f-21797e8dc249',
      data: ''
    },
    {
      id: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4558,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      data: ''
    },
    {
      id: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6297,
      y: 213,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '74092e03-0544-42a0-a499-3278f19873a5',
      data: ''
    },
    {
      id: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7505,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '583acaed-3914-470b-a17f-69f0e67d92ab',
      data: ''
    },
    {
      id: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8380,
      y: 614,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      data: ''
    },
    {
      id: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10108,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'orchid_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '5e0141b9-e88c-4195-9c3a-41026c2f0f02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: 'eac7b762-4daa-4f48-a00f-fa9842083630',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_harvest_map',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: '1c1c11b6-3bec-42ac-9ba7-734666ce9f9e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'd1659629-b52b-4f7a-9540-f46fdd47b041',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tobacco_harvest_map',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'c0951141-6c84-4809-9f82-95dafdb20791',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: '9b6a42ce-3523-4770-bb25-bf8564dbb68a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_harvest_map',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: 'eebc8c9c-a331-443b-916c-21e0b62c9e5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '37c498a2-2982-4a27-ab11-ad78a4d1b579',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tea_harvest_map',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '58315196-25c5-41cf-b5b5-2686aef5cf8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: 'd042d300-813b-485a-9131-9c87b3fd752e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_harvest_map',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: '02371518-93f5-4aa0-9cbf-601b79c46a84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    },
    {
      id: 'a0c529bc-64cb-4fdf-b45c-523b7628ab68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'durian_harvest_map',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout30 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
